import { render, staticRenderFns } from "./hub_management.vue?vue&type=template&id=fa1ab1ca"
import script from "./hub_management.vue?vue&type=script&lang=js"
export * from "./hub_management.vue?vue&type=script&lang=js"
import style0 from "./hub_management.vue?vue&type=style&index=0&id=fa1ab1ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports